import React from 'react'
import { observer } from 'mobx-react-lite'
import StoriesStore from 'stores/stories'
import { useStore } from 'hooks'
import THEME from 'utils/theme'
import StoryHtml from 'components/StoryHtml'
import StoryMeta from 'components/StoryMeta'
import StoryTags from 'components/StoryTags'
import StoryVideoPlayer from 'components/StoryVideoPlayer'
import PodcastPlayer from 'components/PodcastPlayer'
import Gallery from 'components/Gallery'
import RnrConfigAd, { LOCATIONS } from 'components/RnrConfigAd'

const BlogDetail = () => {
  const storiesStore = useStore(StoriesStore)
  const story = storiesStore.current
  const videoSource = storiesStore.currentVideoSource

  return (
    <>
      <div className='container'>
        <RnrConfigAd location={LOCATIONS.VIEW_PAGE_TOP_BANNER} />
        <div className='row row--main'>
          <div className='col col--main'>
            <article className='story'>
              <header className='story__header'>
                <h1 className='story__title'>{story.title}</h1>
                <StoryMeta story={story} placement='top' hideComments={true} />
              </header>
              <div className='story__content'>
                {story.type === 'barstool_original' && videoSource && (
                  <StoryVideoPlayer story={story} storyVideoSource={videoSource} />
                )}
                {story.type === 'podcast' && <PodcastPlayer story={story} />}
                {story.type === 'gallery' && <Gallery story={story} />}
                <StoryHtml story={story} />
                <StoryTags tags={story.tags} />
              </div>
              <StoryMeta story={story} placement='bottom' hideComments={true} />
            </article>
          </div>
          <div className='col col--sidebar'>
            <RnrConfigAd location={LOCATIONS.VIEW_PAGE_SIDE_BOX} />
          </div>
        </div>
      </div>
      <style jsx global>{`
        .layout {
          max-height: 100vh;
        }
      `}</style>
      <style jsx>{`
        .container {
          padding-left: 0;
          padding-right: 0;
        }
        .container > .row {
          display: grid;
          grid-template-columns: 1fr 300px;
          grid-column-gap: 30px;
          margin-left: 0;
          margin-right: 0;
        }
        .container > .row > .col {
          padding: 0;
        }
        .col--sidebar {
          position: sticky;
          top: 1rem;
          align-self: start;
        }
        @media (max-width: 480px) {
          .col--main {
            padding-left: 0;
            padding-right: 0;
          }
        }
        @media (min-width: 480px) {
          .container {
            padding-left: 15px;
            padding-right: 15px;
          }
        }
        @media (max-width: ${THEME.BREAKPOINTS.SM - 1}px) {
          .container > .row {
            grid-template-columns: 1fr;
          }
        }
        .story {
          background-color: white;
          box-shadow: ${THEME.BOX_SHADOW.DEFAULT};
          margin-bottom: 20px;
        }
        .story__title {
          padding: 8px 18px;
          font-size: 20px;
          line-height: 25px;
          font-weight: bold;
          letter-spacing: -0.1px;
          margin: 0;
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .story__title {
            font-size: 32px;
            line-height: 40px;
          }
        }
        .story__content {
          padding: 16px;
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .story__content {
            padding: 16px 32px;
          }
        }
        .storyComments-container {
          margin-top: 20px;
          margin-bottom: 20px;
          padding: 4px 16px;
          background-color: white;
          box-shadow: ${THEME.BOX_SHADOW.DEFAULT};
        }
      `}</style>
    </>
  )
}

export default observer(BlogDetail)
